import Vue from 'vue'
import router from '@/configuracoes/roteador'
import store from '@/configuracoes/stores'
import ajax from '@/configuracoes/requisicoes'
import plugins from '@/configuracoes/plugins'

Vue.config.productionTip = false

new Vue({
    el: '#root',
    template: '<router-view />',
    router,
    store,
})
